export enum SearchType {
    TO_RENT = 'to-rent',
    FOR_SALE = 'for-sale',
    NEW_HOMES = 'new-homes',
    NEW_HOMES_DEVELOPMENTS = 'new-homes-dev',
    HOME_VALUES = 'home-values',
    HOUSE_PRICES = 'house-prices',
    REMORTGAGE = 'remortgage',
    FIND_AGENTS = 'find-agents',
    MORTGAGE_CALCULATOR = 'mortgage-calculator',
    VAL_PPC_1 = 'valuation-ppc1',
    VAL_PPC_2 = 'valuation-ppc2',
    VAL_PPC_3 = 'valuation-ppc3',
    RESEARCH_HUB = 'research',
    HOMEPAGE = 'homepage',
}
